<ng-container *ngIf="$isLoading()">
  <cbre-spinner-loading-indicator></cbre-spinner-loading-indicator>
</ng-container>

<ng-container *ngIf="$hasError() && !$isLoading()">
  <miq-error-page-st></miq-error-page-st>
</ng-container>

<!-- Mount as soon as we have JWT + URLs so scripts load in the background.
     Keep hidden (visibility:hidden preserves layout) until kads-ready fires
     so there is no blank screen between the API spinner disappearing and
     KADS actually rendering. -->
<ng-container *ngIf="!$hasError() && $scriptsReady()">
  <miq-kads-embedded
    [kadsBaseUrl]="baseUrl"
    [scriptPath]="jsPath"
    [runtimePath]="runtimePath"
    [cssPath]="cssPath"
    [parentApp]="'MarketIQ'"
    [userId]="userId"
    [initialRoute]="derivedInitialRoute"
    [style.visibility]="$isLoading() ? 'hidden' : 'visible'"
    (kadsReady)="onKadsReady()"
    (handleError)="onErrorWhenEmbedding()"
  >
  </miq-kads-embedded>
</ng-container>
